import { useNavigate } from "react-router-dom";

const subcategories = [
  {
    id: 1,
    title: "Soft Beige\nLiving Rooms",
    text: "Warm neutrals, soft fabrics, and light-filled comfort.",
    button: "View Soft Beige Spaces",
    path: "/living-room/soft-beige",
    image: "https://public.readdy.ai/ai/img_res/e4784236f6ebd844b5391ff4374553dd.jpg",
    accent: "#D9CEBC",
  },
  {
    id: 2,
    title: "Minimal Warm\nInteriors",
    text: "Clean lines, calm textures, and simple styling with warmth.",
    button: "Explore Minimal Interiors",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=minimal%20warm%20interior%20living%20room%20clean%20lines%20cream%20walls%20natural%20wood%20floor%20simple%20minimal%20furniture%20warm%20tones%20linen%20fabric%20ceramics%20plants%20calm%20peaceful%20editorial%20architecture%20photography%20neutral%20palette&width=800&height=1000&seq=lr_sub2&orientation=portrait",
    accent: "#C8BAA8",
  },
  {
    id: 3,
    title: "Natural Light\nSpaces",
    text: "Airy living rooms shaped by sunlight, linen, and soft wood.",
    button: "See Light-Filled Rooms",
    path: "#inspiration-grid",
    image: "https://readdy.ai/api/search-image?query=natural%20light%20airy%20living%20room%20large%20windows%20sheer%20linen%20curtains%20morning%20sunlight%20warm%20wood%20floor%20cream%20sofa%20plants%20minimal%20decor%20bright%20open%20space%20peaceful%20serene%20editorial%20photography%20neutral%20tones&width=800&height=1000&seq=lr_sub3&orientation=portrait",
    accent: "#B5A898",
  },
];

export default function LRSubcategories() {
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    if (path.startsWith("#")) {
      const el = document.querySelector(path);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(path);
    }
  };

  return (
    <section className="py-24 px-8 md:px-16 max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="text-center mb-16">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Browse by Style
        </p>
        <h2
          className="text-[#2C2825] text-3xl md:text-4xl"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Find Your Style
        </h2>
      </div>

      {/* Three editorial blocks */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {subcategories.map((sub) => (
          <div key={sub.id} className="group flex flex-col">
            {/* Image */}
            <div className="relative overflow-hidden rounded-2xl bg-[#F5F1E8] aspect-[3/4] mb-6">
              <img
                src={sub.image}
                alt={sub.title.replace("\n", " ")}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              {/* Soft bottom gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              {/* Number badge */}
              <div className="absolute top-5 right-5">
                <span
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#FAF7F0]/80 text-[#6B5E53] text-xs font-medium"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  0{sub.id}
                </span>
              </div>
            </div>

            {/* Text */}
            <div className="flex flex-col flex-1">
              <h3
                className="text-[#2C2825] text-xl md:text-2xl leading-snug mb-3 whitespace-pre-line"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {sub.title}
              </h3>
              <p
                className="text-[#8B8378] text-sm leading-relaxed mb-6 flex-1"
                style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
              >
                {sub.text}
              </p>
              <button
                className="self-start inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-6 py-2.5 rounded-full text-xs tracking-[0.14em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
                onClick={() => handleClick(sub.path)}
              >
                {sub.button}
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-[10px]" />
                </span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
